// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__XwvVC","title":"AfterFrontImage_title__1f1qP"};